import React from 'react'
import { Alert, Box, Button, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useTranslation } from 'react-i18next';

interface PropsType{
    pageName:string,
    setPage:(name:string) => void
}

/**
 * サーバとのやりとりでエラーが発生したときに表示する
 */
export function ProcessError({pageName, setPage}:PropsType) {

    const [t] = useTranslation();
    
    function BackProcess() {
        if (pageName === "") {
            window.location.href = "/competition/registration";
        } else {
            setPage(pageName)
        }
    }

    return(
        <>
            <Box>
                <Typography 
                    variant='h4'
                    sx={{
                        textAlign:"left",
                        mt:1
                    }}
                >
                    {t("ProcessError.Title")}<br/>
                </Typography>   
                <Alert icon={false} severity="error"
                    sx={{
                        mt:1,
                        textAlign:"left"
                    }}
                >
                    {t("ProcessError.Text1")}<br/>
                    {t("ProcessError.Text2")}
                </Alert>
                <Grid2 container spacing={1} mt={1}>
                    <Grid2>
                        <Button variant="outlined" onClick={BackProcess}>{t("Common.Back")}</Button>
                    </Grid2>
                </Grid2>
            </Box>  
        </>
    );

}